// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"732590cc","218":"c5c33751","256":"33010c31","491":"d4946ab0","513":"bc5e1050","689":"10c6931d"}[chunkId] + ".chunk.js";
};